
import "./Css/app.css";
import "./Css/window.css";
import "./Css/DeviceMenuButton.css";
import "./Css/TooltipLabel.css";
import "./Css/DeviceBox.css";
import "./Css/LoginPage.css";
import "./Css/menu.css";
import "./Css/snack.css";

import { Button, DestroyingPatternContentSwitcher, HashRef, ModalWindow, MultilineInput, NumberInput, Root, Select, Snack, TextInput } from "@tblabs/truffle";
import { LoginPage } from "./Pages/LoginPage";
import { ConfigProvider } from "./Services/ConfigProvider";
import { PanelPage } from "./Pages/PanelPage";
import { Server } from "./Services/Server";
import { PasswordsAutosaver } from "./Components/PasswordsAutosaver";
import { DemoPage } from "./Demo/DemoPage";
import { AuthService } from "./Services/AuthService";
import { Logger } from "./Components/Logger";
import { DevicesManager } from "./Services/DevicesManager";


ModalWindow.DefaultCssClasses = "tf-modal-window";
ModalWindow.Hook = "body";
TextInput.DefaultCssClasses = "uk-input";
NumberInput.DefaultCssClasses = "uk-input";
Button.DefaultCssClasses = "uk-button";
MultilineInput.DefaultCssClasses = "uk-textarea";
Select.DefaultCssClasses = "uk-select";
Snack.DefaultCssClasses = "tf-snack";

(async () =>
{
    console.log('NODE_ENV:', process.env.NODE_ENV);
    console.log('WATCHER_LOGIN_PAGE:', process.env.WATCHER_LOGIN_PAGE);
    console.log('WATCHER_WATCH_PAGE:', process.env.WATCHER_WATCH_PAGE);
    console.log('DROPBOX_PAGE:', process.env.DROPBOX_PAGE);
    console.log('TUTORIAL_PAGE:', process.env.TUTORIAL_PAGE);


    const root = new Root("body", "root");

    const _config = new ConfigProvider();
    const _logger = new Logger();
    const _auth = new AuthService(_config, _logger);
    const _server = new Server(_config, _auth);
    const _devices = new DevicesManager(_server);

    PasswordsAutosaver.Init();

    const pages = new DestroyingPatternContentSwitcher(new HashRef()).Class("page-switcher")
        .AddContent("panel", () => new PanelPage(_server, _devices, _auth, _logger))
        .AddContent("login", () => new LoginPage(_auth, _config))
        .AddContent("demo", () => new DemoPage(_auth, _logger))
        // .AddContent("regenerate/:tid", ({ tid }) => new RegeneratePage(_devices, _auth, tid))
        .AddDefaultContent(() => new LoginPage(_auth, _config))
        .Refresh();

    root.Append(pages);
})()

